document.addEventListener(
  "DOMContentLoaded",
  function() {
    // Intercom
    var appIds = {
      "www.fondesk.jp": "t1xiwdfz",
      "stg.fondesk.jp": "ci36i724",
      "dev.fondesk.jp": "jkbqsej0"
    };
    window.intercomSettings = {
      app_id: appIds[location.hostname] || "qe7njctt",
      custom_launcher_selector: "#intercom-launcher"
    };

    (function() {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
      } else {
        var d = document;
        var i = function() {
          i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function() {
          var s = d.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://widget.intercom.io/widget/{{INTERCOM_APP_ID}}";
          var x = d.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        };
        if (w.attachEvent) {
          w.attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();

    // Intercom
    (function() {
      var button = document.createElement("div");
      button.setAttribute("id", "intercom-launcher");
      var image = document.createElement("img");
      image.src =
        "https://www.fondesk.jp/assets/images/intercom-button-pelikan.svg";
      button.appendChild(image);
      var body = document.getElementsByTagName("body")[0];
      body.appendChild(button);
      window.Intercom("onShow", function() {
        button.style.display = "none";
      });
      window.Intercom("onHide", function() {
        button.style.display = "block";
      });
      var loadingCheckInterval = setInterval(function() {
        if (window.Intercom.booted) {
          button.setAttribute("class", "booted");
          clearInterval(loadingCheckInterval);
        }
      }, 1000);
    })();

    // 「お問い合わせ」をクリックするとIntercomが開く
    var intercomButton = document.getElementsByClassName("showIntercom");
    if (intercomButton) {
      for (var i = 0; i < intercomButton.length; i++) {
        intercomButton[i].addEventListener(
          "click",
          function(event) {
            if (window.Intercom && window.Intercom.booted) {
              window.Intercom("showNewMessage");
              event.preventDefault();
            }
          },
          false
        );
      }
    }
  },
  false
);
